import { useLocation, useNavigate } from "react-router-dom";
import type { SubjectDto } from "@mmm/contracts";
import { IconButton } from "../ui/IconButton.js";
import { useSubjectDialog } from "./SubjectDialogProvider.js";
import { Badge, Card, ColorDot, useT } from "@mmm/ui";
interface SubjectCardProps {
  subject: SubjectDto;
  compact?: boolean;
}

export function SubjectCard({ subject, compact = false }: SubjectCardProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { openEdit } = useSubjectDialog();
  const t = useT();
  const backTo =
    location.pathname === "/subjects"
      ? "/subjects"
      : location.pathname === "/dashboard"
        ? "/dashboard"
        : null;

  return (
    <Card
      className={`mmm-subject-card ${compact ? "mmm-subject-card--compact" : ""}`.trim()}
      style={{
        opacity: subject.status === "archived" ? 0.75 : 1,
      }}
      onClick={() => navigate(`/subjects/${subject.id}`, backTo ? { state: { backTo } } : undefined)}
    >
      <ColorDot
        color={subject.color}
        size={compact ? 12 : undefined}
        square
        className="mmm-subject-card-swatch"
        style={{ opacity: subject.status === "archived" ? 0.45 : 1 }}
      />

      {!compact && (
        <IconButton
          icon="edit"
          label={t("subjects.editNamed", { title: subject.title })}
          className="mmm-subject-card-menu"
          onClick={(event) => {
            event.stopPropagation();
            openEdit(subject);
          }}
        />
      )}

      <span className="mmm-subject-card-title">{subject.title}</span>

      {!compact && (
        <span className="mmm-subject-card-status">
          <Badge tone={subject.status === "active" ? "success" : "neutral"}>
            {subject.status === "active" ? t("common.active") : t("common.archived")}
          </Badge>
        </span>
      )}
    </Card>
  );
}
